<template>
    <b-modal
        id="storeVouchers"
        title="Store Vouchers"
        ref="viewStoreVouchers"
        size="lg"
        hide-footer
        @hidden="closeModal">
        <div>
            <div class="mb-3">
                <span class="text-muted">Voucher: </span><b>{{ modal.storeVouchers.name }}</b>
            </div>
            <b-row>
                <b-col md="6" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
                    <div class="filter-wrapper">
                        <b-input-group prepend class="shadow-none border rounded">
                            <b-form-input placeholder="Search" v-model="keyword" @keyup.native="search(true)" maxlength="30"></b-form-input>
                            <b-dropdown text="Advanced" variant="primary" slot="append">
                                <b-dropdown-item
                                    v-for="(option, index) in storeVoucherCodesAdvancedOptions"
                                    :key="'advance_option_' + index"
                                    @click="selectAdvanceOption(option.value)">
                                    {{ option.text }}
                                    <i class="ml-1" v-if="storeVoucherCodesSelectedAdvancedOption === option.value">
                                        <img width="15" height="15" src="@/assets/images/checked-symbol.svg" alt="" class="mr-1">
                                    </i>
                                </b-dropdown-item>
                            </b-dropdown>
                        </b-input-group>
                    </div>
                </b-col>
                <b-col md="3" class="mb-3 mb-sm-3 mb-md-0 mb-lg-0">
                    <div class="filter-wrapper">
                        <b-form-select v-model="selectedOption" :options="options" class="shadow-none border rounded" />
                    </div>
                </b-col>
            </b-row>
            <VoucherCodesList />
        </div>
    </b-modal>
</template>

<script>
import { mapState } from "vuex";
import VoucherCodesList from "@/views/dstore/store-vouchers/VoucherCodesList";
export default {
    name: "ViewStoreVouchers",
    props: ["status"],
    components: {
        VoucherCodesList
    },
    computed: {
        ...mapState("estoreVouchers", [
            "modal",
            "storeVoucherCodesAdvancedOptions",
            "storeVoucherCodesSelectedAdvancedOption",
        ])
    },
    data() {
        return {
            keyword: "",
            options: [
                { value: "all", text: "All Status" }
            ],
            selectedOption: "all"
        }
    },
    methods: {
        closeModal: function() {
            this.$store.commit("estoreVouchers/setModal", {
                type: "storeVouchers",
                status: false
            });
        },
        selectAdvanceOption(value) {
            this.$store.commit("estoreVouchers/setStoreVoucherCodesSelectedAdvancedOption", value);
            // if (this.keyword.trim() !== "") {
                this.search(true);
            // }
        },
        async search(newSearch = false) {
            let param = {
                payload: {
                    store_voucher_uuid: this.modal.storeVouchers.uuid,
                    filters: {
                        is_used: this.storeVoucherCodesSelectedAdvancedOption,
                        keyword: this.keyword,
                        column: "all"
                    }
                },
                page: newSearch === true ? 1 : page
            };

            if (this.keyword.trim() === "") {
                this.$store.dispatch("estoreVouchers/viewStoreVoucherCodes", param);
            }

            if (newSearch) {
                this.$store.commit("estoreVouchers/setStoreVoucherCodesEmptyText", "Searching...");
                this.$store.commit("estoreVouchers/setStoreVoucherCodesIsSearching", true);
            }

            let _this = this;
            this.$store.dispatch("estoreVouchers/viewStoreVoucherCodes", param).then(() => {
                _this.$store.commit("estoreVouchers/setStoreVoucherCodesEmptyText", 'No results found for "' + _this.keyword + '"');
                _this.$store.commit("estoreVouchers/setStoreVoucherCodesIsSearching", false);
            });
        }
    },
    watch: {
        status: function(status) {
            if (status == true) {
                this.$refs.viewStoreVouchers.show();
            } else {
                this.$refs.viewStoreVouchers.hide();
                this.keyword = "";
                this.$store.commit("estoreVouchers/setStoreVoucherCodesSelectedAdvancedOption", "all");
                this.$store.commit("estoreVouchers/setStoreVoucherCodesKeyword", "");
            }
        },
        keyword: function(value) {
            this.$store.commit("estoreVouchers/setStoreVoucherCodesKeyword", value);
        }
    }
};
</script>
